module.exports = __webpack_public_path__ + "static/media/Btn-chevron-White.baacc9dc.svg";